import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import { repliValidator } from '../../../components';
import MessageForm from './MessageForm.component';

import useStyles from './Create.style';

import Cookies from 'universal-cookie';


const cookies = new Cookies();

const Update = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { messageId } = useParams();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [sending, setSending] = useState(false);
    const [saveResult, setSaveResult] = useState({});

    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');

    const validator = useRef(repliValidator());

    useEffect(() => {
        if (saveResult.severity === 'success') {
            setTimeout(() => props.history.push("/provider/message"), 2000);
        }
    }, [saveResult, props.history]);

    useEffect(() => {
        const getMessage = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_MESSAGE}/${messageId}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                let json = await response.json();
                if (!response.ok) {
                    setError(json.message || json.errors[0].msg);
                    return;
                };
                setTitle(json.title);
                setBody(json.body);
            } catch (error) {
                console.log(error);
                setError(`${t('module.provider.editMessage.message.fetchDataFailure')}. ${t('common.message.error.seeLog')}.`);
            } finally {
                setLoading(false);
            }
        };

        getMessage();
        validator.current.showMessages();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [messageId]);

    const handleSubmit = async e => {
        e.preventDefault();

        const isValid = validator.current.allValid();
        if (!isValid) {
            validator.current.showMessages();
            return;
        }

        setSending(true);
        try {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_MESSAGE}/${messageId}`, {
                method: 'put',
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                },
                body: new URLSearchParams({
                    title: title,
                    body: body,
                })
            });
            if (!response.ok) {
                let json = await response.json();
                setSaveResult({
                    severity: 'error',
                    message: json.message || json.errors[0].msg
                });
                return;
            }
            setSaveResult({
                severity: 'success',
                message: t('module.provider.addMessage.message.updateMessageSuccess')
            });
        } catch (error) {
            console.log(error);
            setSaveResult({
                severity: 'error',
                message: `${t('module.provider.addMessage.message.addMessageFailure')}. ${t('common.message.error.seeLog')}.`
            });
        } finally {
            setSending(false);
        }
    }

    if (error) return <Alert severity="error">{error}</Alert>

    return (
        <div>
            <Typography variant="h4" className={classes.title}>
                {t('module.provider.addMessage.title')}
            </Typography>
            {saveResult.message &&
                <Alert severity={saveResult.severity}>{saveResult.message}</Alert>
            }
            <MessageForm
                loading={loading}
                submitted={true}
                validator={validator}
                sending={sending}
                title={title}
                body={body}
                onSubmit={handleSubmit}
                onTitleChange={e => setTitle(e.target.value)}
                onBodyChange={e => setBody(e.target.value)}
            />
        </div>
    );
};

export default Update;